import { render } from "./NoticeModal.vue?vue&type=template&id=0985427c&scoped=true"
import script from "./NoticeModal.vue?vue&type=script&lang=js"
export * from "./NoticeModal.vue?vue&type=script&lang=js"

import "./NoticeModal.vue?vue&type=style&index=0&id=0985427c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0985427c"]])

export default __exports__